export default __webpack_public_path__ + "static/media/confetti.fa6620a5.png";